import { Filter, X } from "lucide-react";
import React from "react";
import { Button } from "@mantine/core";

interface QueryFilterButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  filterCount?: number;
  onClearFilters?: () => void;
  showIndicator?: boolean; // New prop to show indicator without count
}

const QueryFilterButton: React.FC<QueryFilterButtonProps> = ({
  onClick,
  disabled = false,
  filterCount = 0,
  onClearFilters,
  showIndicator = false,
}) => {
  const hasFilters = filterCount > 0;
  const showFilterState = hasFilters || showIndicator;

  const handleClearClick = (e: React.MouseEvent): void => {
    e.stopPropagation(); // Prevent triggering the main onClick
    onClearFilters?.();
  };

  if (showFilterState) {
    // Active state with filters - light pink button with indicator and clear X
    return (
      <Button
        variant="default"
        onClick={onClick}
        disabled={disabled}
        className="bg-jem-secondary-20t border border-jem-secondary-base hover:bg-jem-secondary-30t disabled:opacity-60
        h-[43px] min-w-[80px] px-3 py-[7px] rounded flex items-center justify-center gap-2"
      >
        <Filter size={16} className="text-jem-primary-base" />
        {hasFilters && (
          <div className="bg-jem-secondary-base rounded-[10px] px-1 mx-2 min-h-[16px] flex items-center justify-center">
            <span className="text-white text-xs font-semibold leading-none">
              {filterCount}
            </span>
          </div>
        )}
        {showIndicator && !hasFilters && (
          <div className="w-2 h-2 bg-jem-secondary-base rounded-full mx-2" />
        )}
        <X
          size={14}
          className="text-jem-primary-base cursor-pointer flex-shrink-0"
          onClick={handleClearClick}
        />
      </Button>
    );
  }

  // Default state - gray outline button with just icon
  return (
    <Button
      variant="outline"
      color="gray"
      onClick={onClick}
      disabled={disabled}
      style={{
        height: "43px",
        width: "43px",
        padding: 0,
      }}
    >
      <Filter size={16} />
    </Button>
  );
};

export default QueryFilterButton;
